import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
import {
  DatePicker as MaterialUIDatePicker,
  MuiPickersUtilsProvider,
  DatePickerProps,
} from '@material-ui/pickers';

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersDay: {
      daySelected: {
        color: '#fff',
      },
    },
  },
} as any);

const DatePicker: React.FC<DatePickerProps> = ({ ...props }) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <ThemeProvider theme={materialTheme}>
        <MaterialUIDatePicker
          autoOk
          disableToolbar
          variant='inline'
          format='dd/MM/yyyy'
          id='date-picker-inline'
          {...props}
        />
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
};

export default DatePicker;
